import { submitEvent, submitEventMerge, submitMerge, submitMiniAction, submitMove, trackOnNextPageImpression } from "@otto-ec/tracking-bct";
import { logger } from "@otto-ec/global-resources/debug";

const debug = logger("reco-cinema.tracking.event-emitter");

const emitMiniActionEvent = (featureIds) => {
    const payload = featureIds.map((featureId) => ({
        featureId,
    }));
    submitMiniAction(payload);
    debug.info("miniaction submitted", payload);
};

const emitSustainabilityLabelClickEvent = (payload) => {
    submitEvent(payload);
    debug.info("sustainability label click tracking (Nexus)", payload);
};

const emitDeselectShoeSizeFilterEvent = (features) => {
    const payload = {
        name: "deselect",
        features,
    };
    submitEvent({}, payload);
    debug.info("clear shoe size filter tracking (Nexus)", payload);
};

const emitCollapsedEvent = (payload) => {
    submitMerge({}, payload);
    debug.info("collapsed cinema tracking (Nexus)", payload);
};

const emitOpenEventMerge = (payload, eventMergeId) => {
    submitEventMerge(eventMergeId, {}, payload);
    debug.info("open cinema event merge tracking", payload);
};

const emitOpenedEvent = (openPayload, additionalOpenedLabels) => {
    submitEvent(additionalOpenedLabels, openPayload);
    debug.info("open cinema tracking (Nexus)", openPayload);
};

const emitClosedEvent = (closePayload, additionalClosedLabels) => {
    submitEvent(additionalClosedLabels, closePayload);
    debug.info("close cinema tracking (Nexus)", closePayload);
};

const emitScrollEvent = (scrollPayload, additionalTrackingLabels) => {
    submitEvent(additionalTrackingLabels, scrollPayload);
    debug.info("scroll cinema tracking (Nexus)", scrollPayload);
};

const emitFreshViewEvent = (payload, baseLevelTrackingLabels = {}) => {
    submitMerge(baseLevelTrackingLabels, payload);
    debug.info("cinema view page tracking (Nexus)", payload);
};

const emitClickEvent = (moveActionPayload, onNextPageImpressionPayload, additionalTrackingLabels) => {
    trackOnNextPageImpression(onNextPageImpressionPayload);
    debug.info("cinema click tile tracking - on next page impression (Nexus)", JSON.stringify(onNextPageImpressionPayload));

    submitMove(additionalTrackingLabels, moveActionPayload);
    debug.info(
        "cinema click tile tracking - move action (Nexus))",
        JSON.stringify(additionalTrackingLabels),
        JSON.stringify(moveActionPayload)
    );
};

const emitActionViewEvent = (payload, eventMergeId, actionName) => {
    const event = {
        name: actionName,
        features: payload,
    };
    submitEventMerge(eventMergeId, {}, event);
    debug.info(`cinema view page tracking - ${actionName} action (Nexus)`, payload);
};

const emitHypotheticalEvent = (payload) => {
    submitMerge(payload);
    debug.info("hypothetical event emitted", payload);
};

const emitRecoAddToCartButtonLabelEvent = (labels, payload) => {
    submitEvent(labels || {}, payload);
    debug.info("Add2CartButton visible label tracking (Nexus)", payload);
};

export {
    emitMiniActionEvent,
    emitSustainabilityLabelClickEvent,
    emitDeselectShoeSizeFilterEvent,
    emitCollapsedEvent,
    emitOpenEventMerge,
    emitOpenedEvent,
    emitClosedEvent,
    emitScrollEvent,
    emitFreshViewEvent,
    emitClickEvent,
    emitActionViewEvent,
    emitHypotheticalEvent,
    emitRecoAddToCartButtonLabelEvent,
};
